// extracted by mini-css-extract-plugin
export default {"tab__container":"routing_tab__container__x0qOq","tab":"routing_tab__RX-e-","active__tab":"routing_active__tab__MtnMy"};